// 微博分享
var fill = function(tmpl, data) {
  for (var k in data) {
    tmpl = tmpl.replace(new RegExp('\\{' + k + '\\}', 'g'), data[k]);
  }
  return tmpl;
};

var shareWeibo = function() {
  var url =
    'http://v.t.sina.com.cn/share/share.php?appkey=1096333005&site={site}&title={content}&pic={imgUrl}&url={url}';
  var weiboData = {
    // url: encodeURIComponent(location.href),
    url: encodeURIComponent('http://act.feng.com/2019back-to-school'),
    site: encodeURIComponent('http://www.feng.com'),
    imgUrl: encodeURIComponent(
      'http://act.feng.com/2019back-to-school/share.jpg'
    ),
    content: encodeURIComponent(
      '#苹果教育优惠#来威锋购机瓜分500万大礼！@威锋网 链接地址：'
    )
  };
  window.open(fill(url, weiboData), '_blank', 'height=500, width=700');
};

export default shareWeibo;


// WEBPACK FOOTER //
// ./src/assets/js/share-weibo.js